import type { IconType } from '../../theme/themes/ThemeTypes';

const ExternalLink: IconType = ({ colour, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={22} height={23} fill="none" {...props}>
    <path
      stroke={colour}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8.824 13.483 21 1.5M21 8.346V1.5h-6.953M10.65 6.282H1.763A.766.766 0 0 0 1 7.045v13.692c0 .419.344.763.763.763h13.692c.419 0 .763-.344.763-.763V11.85"
    />
  </svg>
);

export default ExternalLink;
